import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { IAttachmentType } from "../../../attachmentType/model/AttachmentType";
import { IOrganisation } from "../../model/Organisation";

export interface TAttachmentTypePresentationModel extends IAttachmentType {
  contentTypeName: string;
  contentType: IGenericCodebookItem;
  organisation: IOrganisation;
  organisationName: string;
}

const AttachmentTypePresentationModel = (
  data: IAttachmentType,
  contentType?: IGenericCodebookItem,
  organisation?: IOrganisation
) => {
  const attachmentTypeContentType = contentType;
  const attachmentTypeOrganisation = organisation;
  const handler: ProxyHandler<IAttachmentType> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "contentTypeName":
          return attachmentTypeContentType?.value;
        case "contentType":
          return attachmentTypeContentType;
        case "organisation":
          return attachmentTypeOrganisation;
        case "organisationName":
          return attachmentTypeOrganisation?.name;
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "contentTypeName":
        case "contentType":
        case "organisation":
        case "organisationName":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IAttachmentType, TAttachmentTypePresentationModel>(
    data,
    handler
  );
};

export default AttachmentTypePresentationModel;
